<template>
  <div class="box">
    <GMap id="fullscreen" ref="mapComponent"></GMap>
    <div id="overlay">
      <div id="top-right">
        <b-button variant="primary"  @click="click" style="margin-top: 5px">
          <img :src="require(`@/assets/focus.png`)" width="20px" style="display: inline-block">
          <div style="display: inline-block; vertical-align: middle; margin-left: 8px">ค้นหาจุดตรวจใกล้ท่าน</div>
        </b-button>
        <div style="margin-top: 5px; font-size: 15px; margin-bottom: 0px">
          <a @click="toggleList(!isShowList)"> >> รายชื่อจุดตรวจ <a style="font-weight: bold; color: #ffc107">ทั่วประเทศ</a> << </a>
        </div>

        <div>
          <marquee-text>
            <a style="font-size: 0.8rem">| ข้อแนะนำ: ควรไปตรวจเฉพาะมีอาการไข้สูง และไอแห้ง หรือมีความเสี่ยง เพื่อลดภาระโรงพยาบาล | </a>
          </marquee-text>
        </div>

      </div>
    </div>

    <div id="left-bottom">
      <div>
      <div style="display: inline-block; margin-right: 10px">
        <b-button variant="warning"  @click="$bvModal.show('bv-modal-example')">กลุ่มเสี่ยง คือ?</b-button>
        <b-modal id="bv-modal-example" hide-footer centered>
          <template v-slot:modal-title>
            กลุ่มเสี่ยง คืออะไร?
          </template>
          <div class="d-block text-left">
            <h6>1. ผู้ที่มีอุณหภูมิร่างกายตั้งแต่ 37.5 องศาเซลเซียสขึ้นไป</h6>
            <h6>2. มีอาการไอแห้ง/เจ็บคอ/หายใจลำบาก</h6>
            <h6>3. มีประวัติเดินทางกลับจากประเทศกลุ่มเสี่ยง/หรือสัมผัสกลุ่มเสี่ยง</h6>
            <br>

            <h6>ที่มา กรมควบคุมโรค</h6>
          </div>
        </b-modal>
      </div>

      <div style="display: inline-block; vertical-align: center">
        <b-button  @click="navigateToCurrentLocation">
          <img :src="require(`@/assets/focus.png`)" width="20px" style="display: inline-block">
        </b-button>
      </div>
      </div>

      <div class="credit" @click="$bvModal.show('credit-modal')">
        <div style="display: inline-block; width: 130px; padding: 10px; margin-right: -15px">
            <div style="font-size: 1rem">
              <a style="font-weight: bold">GoCovid</a> <span class="sup">©</span>  <br>
              by ส.ส.ดร.อิสระ
            </div>
        </div>

        <div style="display: inline-block; vertical-align: top">
          <b-img v-bind="mainProps" rounded="circle" :src="require(`@/assets/dicut.png`)"></b-img>
        </div>
      </div>
    </div>

    <b-modal id="credit-modal" hide-footer centered>
      <template v-slot:modal-title>
        GoCovid<span class="sup">©</span> เวอร์ชั่น 1.0.0
      </template>
      <div class="d-block text-left">
        <p style="font-size: 0.8rem">
        ผมและทีมงาน จัดทำ Web Application นี้เพื่อเผยแพร่ข้อมูลจุดตรวจโรค COVID-19 เพื่อให้คนไทยทุกคนได้รับความสะดวกในการเข้าถึงข้อมูล<br><br>
        ข้อมูลต่างๆ ถูกต้อง ณ วันและเวลาที่ทำการบันทึกข้อมูลเท่านั้น ทั้งนี้ ควรตรวจสอบรายละเอียดกับสถานพยาบาลก่อนไปเข้ารับบริการ<br><br>
        สงวนลิขสิทธิ์รูปแบบและวิธีการของโปรแกรมนี้ ห้ามมิให้ผู้ใดทำซ้ำ ดัดแปลง และมิให้นำไปใช้ในเชิงพาณิชย์ใดๆ ทั้งสิ้น<br><br>
        หากมีข้อแนะนำหรือคำถาม กรุณาติดต่อผ่าน Facebook ของผมที่ <a href="https://www.facebook.com/issara.sereewatthanawut/" target="_blank">ดร.อิสระ เสรีวัฒนวุฒิ - Issara Sereewatthanawut</a><br>
        <br>
        ด้วยความห่วงใยและปรารถนาดีครับ
        <br><br>
        ดร.อิสระ เสรีวัฒนวุฒิ<br>
        สมาชิกสภาผู้แทนราษฎร<br>
        แบบบัญชีรายชื่อ พรรคประชาธิปัตย์<br>
        </p>
      </div>
    </b-modal>

    <transition name="slide-fade">
      <div id="list-modal" v-if="isShowList">
        <b-button-group size="sm" style="margin-top: 10px">
          <b-button variant="primary" v-if="listAll">จุดตรวจทั่วประเทศ</b-button>
          <b-button variant="outline-primary" v-else @click="applyListFilter(true)">จุดตรวจทั่วประเทศ</b-button>
          <b-button variant="outline-success" v-if="listAll" @click="applyListFilter(false)">รับตรวจทั่วไป</b-button>
          <b-button variant="success" v-else>รับตรวจทั่วไป</b-button>
        </b-button-group>

        <div class="list">
          <div class="cell" v-for="(m, index) in locations(listAll)">
            <div style="display: inline-block; max-width: 90%">
              <h6 style="font-weight: bold; margin-bottom: 0px;">{{m.name}}</h6>
              <a style="font-size: 0.8rem;">{{m.condition}}</a>
            </div>
            <div style="display: inline-block; float: right;">
              <b-icon icon="info-fill" font-scale="2" @click="navigateToLocation(m)" variant="primary"></b-icon>
            </div>
          </div>

        </div>
      </div>
    </transition>

  </div>
</template>

<script>
    import GMap from "./GMap";
    import { mapGetters, mapState } from 'vuex'
    import MarqueeText from 'vue-marquee-text-component'

    export default {
        name: "MainMap",
        components: {
          GMap,
          MarqueeText
        },
        data() {
          return {
            mainProps: { blankColor: '#777', height: 70, class: 'm1' },
            listAll: true,
            isShowList: false
          }
        },
        computed: {
          ...mapState({
            locations: state => state.locations,
          }),
          ...mapGetters( {
            locations: 'getDisplayableLocation'
          })
        },
        methods: {
          click: function() {
            this.$refs.mapComponent.findNesrest()
          },
          toggleList: function(isShow) {
            this.isShowList = isShow
          },
          applyListFilter: function (isShowAll) {
            this.listAll = isShowAll
          },
          navigateToLocation: function (location) {
            this.$refs.mapComponent.navigateToLocation(location)
          },
          navigateToCurrentLocation: function () {
            this.$refs.mapComponent.navigateToCurrentLocation()
          },
          isListDisplayed: function () {
            return this.isShowList
          }
        }
    }


</script>

<style scoped>
  h6 {
    font-size: 0.8rem;
  }
  .list {
    overflow-y: auto;
    height: 78%;
    text-align: left;
    margin: 20px 15px 15px;
    bottom: 0px;
  }

  .cell {
    margin-bottom: 20px;
    vertical-align: center;
  }

  #left-bottom {
    text-align: left;
    position: absolute;
    bottom: 10px;
    left: 10px;
    font-size: 15px;
    color: black;
  }

  .credit {
    background: rgba(255, 255, 255, 0.8);
    padding: 10px;
    margin-top: 10px;
  }

  #list-modal {
    position: absolute;
    left: 0px;
    width: 100%;
    bottom: 0px;
    height: 40%;
    background: white;
  }

  #top-right{
    text-align: center;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    background: rgba(255, 255, 255, 0.8);
  }

  #fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
  }
  .vertical-center {
    vertical-align: bottom;
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(40%);
    opacity: 0;
  }
  .sup {
    font-size: 8px;
    vertical-align: super;
  }
</style>
